import React from 'react';
import Modal from 'shared/components/modal';
import {Form, Formik} from 'formik';
import FormikRadioButtons from '../formik-radio-buttons';
import UserService from '../../services/UserService';

interface Props {
  handleClose: () => void;
}

function ShareDataModal({handleClose}: Props) {
  const shareDataOptions = [
    {value: 'true', label: 'Yes! Share my data with all colleges'},
    {value: 'false', label: 'No, only share my data with colleges I’m following'},
  ];

  const handleSubmit = async (values) => {
    await UserService.update({shareDataWithAllSchools: values.shareDataWithAllSchools}, [
      'shareDataWithAllSchools',
    ]);

    handleClose();
  };

  return (
    <Modal show className="welcome-modal" onClose={handleClose}>
      <Modal.TextHeader onClose={handleClose}>
        Share your Profile with all colleges
      </Modal.TextHeader>
      <Formik initialValues={{}} onSubmit={handleSubmit} enableReinitialize>
        {(formik) => (
          <>
            <Modal.Body>
              <div>When you share your data with all participating colleges:</div>
              <ul>
                <li>Colleges can discover you — even ones you might not have considered</li>
                <li>You’ll hear about more opportunities that match your interests</li>
                <li>It increases your chances of finding the right fit</li>
              </ul>
              <Form autoComplete="off">
                <FormikRadioButtons
                  name="shareDataWithAllSchools"
                  options={shareDataOptions}
                  required
                  className="mt-20"
                />
                <div className="mt-16">
                  Colleges may reach out directly with information and opportunities. You can change
                  this setting anytime in your account.
                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer
              primaryButton={{
                onClick: formik.submitForm,
                width: 85,
                disabled: formik.isSubmitting || !formik.isValid,
                text: formik.isSubmitting ? 'Saving...' : 'Save',
              }}
            />
          </>
        )}
      </Formik>
    </Modal>
  );
}

export default ShareDataModal;
